import { AlertTriangle, Check, CloudOff, Loader2 } from 'lucide-react';

export const SaveIndicator = ({ status, onRetry }) => {
  const s = status.state;
  const base = 'inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em]';
  if (s === 'saving' || s === 'retrying' || s === 'pending') {
    return (
      <span className={`${base} text-matte/60`} data-testid="stage-save-status" data-state={s}>
        <Loader2 size={12} className="animate-spin" /> {s === 'retrying' ? 'Retrying…' : s === 'pending' ? (status.restored ? 'Restoring unsaved changes…' : 'Unsaved changes') : 'Saving…'}
      </span>
    );
  }
  if (s === 'saved') {
    return <span className={`${base} text-emerald-700`} data-testid="stage-save-status" data-state="saved"><Check size={12} /> Saved · {status.at.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}</span>;
  }
  if (s === 'offline') {
    return <span className={`${base} text-amber-700`} data-testid="stage-save-status" data-state="offline"><CloudOff size={12} /> Offline. Will save when you reconnect</span>;
  }
  if (s === 'error') {
    return (
      <span className={`${base} text-red-700`} data-testid="stage-save-status" data-state="error">
        <AlertTriangle size={12} /> {status.message}
        <button onClick={onRetry} className="underline" data-testid="stage-save-retry-button">Retry</button>
      </span>
    );
  }
  if (s === 'conflict') {
    return <span className={`${base} text-red-700`} data-testid="stage-save-status" data-state="conflict"><AlertTriangle size={12} /> Not saved: updated elsewhere</span>;
  }
  return <span className={`${base} text-matte/40`} data-testid="stage-save-status" data-state="idle">All changes saved</span>;
};
